import { Skills } from "../../../../features/Skills";
import { SkillsPage } from "../../../../pages/SkillsPage";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const skillsPageRouteConfig: AppRouteProps = {
  path: appRouterPaths.skills.root,
  element: <SkillsPage />,
  name: "Навыки",
  children: appRouterPaths.skills.item
    ? [
        {
          path: appRouterPaths.skills.item,
          element: <Skills />,
          name: "Навык",
        },
      ]
    : undefined,
};
